<template>
    <div class="perinfo">
        <div class="header">
            <div class="logo">
                <img src="static/lg.png">
            </div>
            <div class="shortcut">
                <!-- <span class="shortcut-inner">
                    <span>中文简体</span>
                </span> -->
                <span class="shortcut-inner cursor">
                    {{$store.state.currentUser != null ? ($store.state.currentUser.uid && $store.state.currentUser.name ? `${$store.state.currentUser.uid} (${$store.state.currentUser.name})` : null) : null}}，<a v-if="$store.state.currentUser && $store.state.currentUser.uid" @click="dropOut">退出</a>
                </span>
                <!-- <span class="shortcut-inner"><a>意见反馈</a></span> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            
        }
    },
    methods: {
        dropOut () {
            this.$confirm('确定退出当前登录吗？', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var a  = `${process.env.SSO}/logout?service=${process.env.Login_OUT}`;
                console.log(a);
                window.location.href = `${process.env.SSO}/logout?service=${process.env.Login_OUT}`;
            }).catch(() => {
                
            });
        }
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .perinfo {
        height: 60px; width: 100%; background: #292e41; border-bottom: 1px solid #ddd; overflow: hidden; z-index: 10001;
        .header{
            margin: 0 auto; height: 100%; padding: 0 20px;
            .logo {
                width:180px;height:32px;padding-top: 14px; float: left;
                img {
                    width: 160px;vertical-align: middle; cursor: pointer;
                }
            }
            .shortcut {
                height: 100%;font-size: 12px; float: right;
                .shortcut-inner{
                    display: inline-block;
                    font-size: 12px;
                    line-height: 20px;
                    margin: 20px 6px;
                    color: #cbced8;
                    cursor: pointer;
                }
                .cursor{
                    a{
                        cursor: pointer;
                    }
                    cursor: inherit;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Head.vue